import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
//import Moment from "moment";
import DatePicker from "react-datepicker";
import { LinkContainer } from "react-router-bootstrap";
import ReactTable from "react-table";
import 'react-table/react-table.css';



export default class StrataUnitList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            dataSet: "strataUnits",
            dataRecord: "strataUnits",
            dataSetPrimaryKey: "property_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

                       
        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {
        if (!this.props.isAuthenticated) { // if false
            return;
        }
      

        this.setState({ isLoading: false });      
    }


    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);
            
            

        } catch (e) {
            alert("Error saving");
        }
    }





    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        if (event.detail !== 0) {
            event.preventDefault();
            if (event.detail !== 0) {
                let data = [...this.props.data];
                var r = window.confirm("Are you sure you want to delete this record?");
                if (r === true) {
                    console.log(cellInfo);

                    data[cellInfo.index].archived_date = new Date();
                    await this.handleDataSave(data[cellInfo.index]).then((result) => {
                        data.splice(cellInfo.index, 1);
                        this.props.updateTableState(data, this.state.dataSet);
                    }
                    )
                };
            }
        }
    };

    handleInputChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = val;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

   

    handleSave = async (cellInfo, event) => {

        this.setState({ showAlert: false });
        let data = [...this.props.data];        
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }
        // if (data[0].hasOwnProperty("unit_sort")) {
        //     data.sort(function (a, b) { return a.unit_sort - b.unit_sort });
        // }
        if (data[0].hasOwnProperty("sort_order")) {
            data.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        this.props.updateTableState(data, this.state.dataSet);
    }


    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

       

        if (["unit_sort"].indexOf(cellInfo.column.id) >= 0) {
            return (
                <input
                    onChange={this.handleInputChange.bind(null, cellInfo)}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    type="number"
                    className="no-border form-control"
                    value={cellValue}
                    step="0.1"
                />
            );
        }


        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }

  



    renderTable(data) {
        const columns = [
            {
                id: 'selected',
                Header: '',
                maxWidth: 60,
                accessor: 'selected',
                Cell: this.renderEditable,
                style: { textAlign: "center" }
            },
            {
                id: 'property_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'property_id',                
                Cell: e => <LinkContainer to={ {pathname: `/properties/${e.original.property_key}`, state: {tab: "property",data: this.props.data.filter((a) => { if(a.selected){return true;}else{return false;}} ).map(a => a.property_key)}}}><a>{e.value}</a></LinkContainer>,                
                style: { backgroundColor: '#fafafa'}

            }, {
                id: 'property_key',
                Header: 'Cityscope Reference',
                accessor: 'property_key',
                maxWidth: 125,
                style: { backgroundColor: '#fafafa'}
                
            },{
                id: 'unit_sort',
                Header: 'Unit Sort',
                accessor: 'unit_sort',
                maxWidth: 85,
                Cell: this.renderEditable,
                style: { textAlign: "center",backgroundColor: '#fafafa' }

            }, {
                id: 'unit_number',
                Header: 'Unit Number',
                maxWidth: 85,
                accessor: 'unit_number',
                style: { textAlign: "center" ,backgroundColor: '#fafafa'}

            }, {
                id: 'unit_number_suffix',
                Header: 'Unit Number Suffix',
                maxWidth: 85,
                style: { backgroundColor: '#fafafa'},
                accessor: 'unit_number_suffix'

            },
            {
                id: 'description',
                Header: 'Description',            
                accessor: 'description',
                
                style: { textAlign: "left",backgroundColor: '#fafafa','white-space': 'unset' }

            },
            {
                id: 'title_details',
                Header: 'Title',            
                accessor: 'title_details',

                style: { textAlign: "left",backgroundColor: '#fafafa' }

            }, {
                id: 'address_count',
                Header: 'Address Count',
                maxWidth: 85,
                accessor: 'address_count',
                style: { textAlign: "center",backgroundColor: '#fafafa' }

            }, {
                id: 'building_name_count',
                Header: 'Building Name Count',
                maxWidth: 85,
                accessor: 'building_name_count',
                style: { textAlign: "center",backgroundColor: '#fafafa' }

            }, {
                id: 'classification_count',
                Header: 'Classification Count',
                maxWidth: 85,
                accessor: 'classification_count',
                style: { textAlign: "center",backgroundColor: '#fafafa' }

            }, {
                id: 'owner_count',
                Header: 'Owner Count',
                maxWidth: 85,
                accessor: 'owner_count',
                style: { textAlign: "center",backgroundColor: '#fafafa' }

            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }



    }


    renderList(data) {
      
            console.log("No data for strata units");
            return null
      
    }

    selectAll = event =>{
        let data = [...this.props.data];
        for(var i=0;i<data.length;i++){
            data[i].selected=true;
        }
        this.props.updateTableState(data, this.state.dataSet);
    }

    deselectAll = event =>{
        let data = [...this.props.data];
        for(var i=0;i<data.length;i++){
            data[i].selected=false;
        }
        this.props.updateTableState(data, this.state.dataSet);
    }

    sortUnits = event =>{
        let data = [...this.props.data];
        data.sort(function (a, b) { return a.unit_sort - b.unit_sort });
        this.props.updateTableState(data, this.state.dataSet);
    }

    renderComponent() {
        return (
            <div className="strataunits">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.props.controlType === "table" && <Row className="show-Container">
                
                <Col className="text-left" >
                <Button variant="primary" type="button" size="sm" onClick={this.sortUnits}>Sort Units</Button>{" "}
                <Button variant="primary" type="button" size="sm" onClick={this.selectAll}>Select All</Button>{" "}
                <Button variant="primary" type="button" size="sm" onClick={this.deselectAll}>Deselect All</Button>{" "}
                {/* <Button variant="primary" type="button" size="sm" onClick={this.addToBrowseList}>Add to Browse List</Button>{" "} */}
                </Col>
                    <Col className="text-right" >

                        

                    </Col>
                </Row>}

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading && this.props.controlType === "table" ? this.renderTable(this.props.data) : this.renderList(this.props.data)}
                        </Col>
                    </Row>
         

            </div>
        );
    }
  render() {
    return (

        <div className="StrataUnitList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
        </div>
    );
  }
}
